const services = [
  { id: 1, name: 'Loading Inspection' },
  { id: 2, name: 'Quality Control' },
  { id: 3, name: 'Pre Shipment' },
  { id: 4, name: 'Supplier Audit' }
]

export default services
